var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCrop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.5V13.4",
    stroke: "#4147D5",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.70008 1.3C3.70008 1.3 3.60008 3.7 4.00008 4.6C4.40008 5.5 6.90008 6.3 6.90008 7.4",
    stroke: "#4147D5",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00005 6.09999C7.00005 6.09999 6.70005 4.09999 5.90005 3.29999C5.10005 2.49999 3.80005 2.99999 3.80005 2.99999",
    stroke: "#4147D5",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00006 10.3C7.00006 9.19999 4.80006 8.79999 4.10006 7.49999C3.40006 6.19999 3.80006 4.89999 3.80006 4.89999C3.80006 4.89999 5.10006 5.49999 5.90006 6.19999C6.70006 6.89999 7.00006 8.99999 7.00006 8.99999",
    stroke: "#4147D5",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00006 13C6.60006 11.9 4.80006 11.7 4.10006 10.4C3.40006 9.1 3.80006 7.8 3.80006 7.8C3.80006 7.8 5.10006 8.5 5.90006 9.1C6.70006 9.7 7.00006 11.9 7.00006 11.9",
    stroke: "#4147D5",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2 1.3C10.2 1.3 10.3 3.7 9.9 4.6C9.5 5.5 7 6.3 7 7.4",
    stroke: "#4147D5",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7 6.09999C7 6.09999 7.3 4.09999 8.1 3.29999C8.9 2.49999 10.2 2.99999 10.2 2.99999",
    stroke: "#4147D5",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7 10.3C7 9.19999 9.2 8.79999 9.9 7.49999C10.6 6.19999 10.2 4.89999 10.2 4.89999C10.2 4.89999 8.9 5.49999 8.1 6.19999C7.3 6.89999 7 8.99999 7 8.99999",
    stroke: "#4147D5",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.9C7.3 11.9 9.2 11.7 9.9 10.4C10.6 9.1 10.2 7.8 10.2 7.8C10.2 7.8 8.9 8.5 8.1 9.1C7.3 9.7 7 11.9 7 11.9",
    stroke: "#4147D5",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.40007 8.8C6.20007 8.7 6.00007 8.6 5.90007 8.5C5.30007 8.2 4.80007 7.8 4.50007 7.3C4.30007 6.9 4.20007 6.3 4.20007 5.7C4.60007 5.9 5.10007 6.3 5.50007 6.6C5.90007 7 6.30007 8.1 6.40007 8.8Z",
    fill: "#D7E0FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5001 7.3C9.2001 7.8 8.7001 8.1 8.1001 8.5C7.9001 8.6 7.7001 8.7 7.6001 8.8C7.8001 8.1 8.1001 7 8.5001 6.6C8.9001 6.3 9.4001 5.9 9.8001 5.7C9.8001 6.2 9.8001 6.9 9.5001 7.3Z",
    fill: "#D7E0FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4 3.69999C8.7 3.39999 9.3 3.39999 9.6 3.39999C9.6 3.79999 9.5 4.19999 9.4 4.39999C9.2 4.79999 8.6 5.09999 8.1 5.49999C7.9 5.59999 7.7 5.79999 7.5 5.89999C7.7 5.19999 8 4.09999 8.4 3.69999Z",
    fill: "#D7E0FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50005 3.69999C5.90005 4.09999 6.20005 5.09999 6.40005 5.89999C6.20005 5.79999 6.00005 5.59999 5.80005 5.49999C5.20005 5.19999 4.70005 4.79999 4.50005 4.39999C4.40005 4.19999 4.30005 3.79999 4.30005 3.39999C4.70005 3.39999 5.20005 3.39999 5.50005 3.69999Z",
    fill: "#D7E0FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M5.90007 11.3C5.40007 11 4.80007 10.7 4.50007 10.2C4.30007 9.90001 4.20007 9.20001 4.20007 8.60001C4.60007 8.80001 5.10007 9.20001 5.50007 9.50001C5.90007 9.90001 6.20007 10.9 6.40007 11.7C6.20007 11.6 6.00007 11.5 5.80007 11.4L5.90007 11.3Z",
    fill: "#D7E0FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5001 10.2C9.2001 10.7 8.6001 11 8.1001 11.4C7.9001 11.5 7.7001 11.6 7.6001 11.7C7.8001 11 8.1001 9.9 8.5001 9.6C8.9001 9.3 9.4001 9 9.8001 8.7C9.8001 9.2 9.8001 9.9 9.5001 10.3V10.2Z",
    fill: "#D7E0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrop);
export default __webpack_public_path__ + "static/media/icon-crop.23d50189b5425960354a57080f21158a.svg";
export { ForwardRef as ReactComponent };